import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	HostListener,
	computed,
	effect,
	input,
	output,
	signal,
	untracked
} from '@angular/core';

@Component({
	selector: 'button[xpDocThumb]',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './xp-doc-thumb.component.html',
	styleUrls: ['./xp-doc-thumb.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpDocThumbComponent {
	src = input('');
	isPdf = input<boolean | null>(null);
	pdfIconSrc = input('');
	emptySrc = input('');
	label = input('');
	caption = input('');
	note = input('');

	open = output<void>();

	private readonly failedSrc = signal<string | null>(null);

	private readonly wantedSrc = computed(() => {
		if (!this.src()) {
			return this.emptySrc();
		}
		if (this.isPdf() === true) {
			return this.pdfIconSrc();
		}
		if (this.isPdf() === false) {
			return this.src();
		}
		return this.emptySrc();
	});

	readonly imageSrc = computed(() => {
		const wanted = this.wantedSrc();
		return wanted === this.failedSrc() ? this.emptySrc() : wanted;
	});

	readonly isEmpty = computed(() => !this.src() || this.isPdf() === null || this.isPdf() === undefined);

	@HostBinding('attr.type')
	readonly buttonType = 'button';

	constructor() {
		/* A failure holds only for the file that failed: when the screen passes that file again later, the tile tries it again. */
		effect(() => {
			this.wantedSrc();
			untracked(() => this.failedSrc.set(null));
		});
	}

	@HostListener('click')
	onClick(): void {
		this.open.emit();
	}

	onImageError(): void {
		this.failedSrc.set(this.wantedSrc());
	}
}
